import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import {
  CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
  CS_INQUIRY_LIST_SORT_OPTION_MODEL,
  CS_INQUIRY_DETAIL_USER_INFO_MODEL,
  CS_INQUIRY_DETAIL_INQUIRY_INFO_MODEL,
} from './models';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';
import { updateStoreWithPath } from '../../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  1:1 문의 리스트
   */
  csInquiryList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  1:1 문의 상세
   */
  csInquiryDetail: {
    /**
     *  유저 정보
     */
    userInfo: CS_INQUIRY_DETAIL_USER_INFO_MODEL,

    /**
     *  문의 정보
     */
    inquiryInfo: CS_INQUIRY_DETAIL_INQUIRY_INFO_MODEL,
  },

  /**
   *  1:1 문의 질문 모달
   */
  csInquiryQuestionModal: {
    isOpen: false,
    data: {},
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [1:1 문의] 1:1 문의 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [1:1 문의 리스트] 1:1 문의 리스트 요청하기
     */
    [actions.GET_INQUIRY_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  1:1 문의 리스트
         */
        draft.csInquiryList = action.payload.csInquiryList;
      });
    },

    /**
     *  [1:1 문의 상세] 1:1 문의 상세 요청하기
     */
    [actions.GET_INQUIRY_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  문의 정보
         */
        draft.csInquiryDetail.inquiryInfo = action.payload.inquiryInfo;
        /**
         *  유저 정보
         */
        draft.csInquiryDetail.userInfo = action.payload.userInfo;
      });
    },

    /**
     *  [1:1 문의 상세] 유저의 다른 문의 내역 조회하기
     */
    [actions.GET_USERS_OTHER_INQUIRY_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  유저 정보
         */
        draft.csInquiryDetail.userInfo.usersOtherInquiry = action.payload.userInfo.usersOtherInquiry;
      });
    },

    /**
     *  [1:1 문의 상세] 1:1 문의 답변 작성하기
     */
    [actions.REPLY_INQUIRY_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  문의 답변 작성 일자
         */
        draft.csInquiryDetail.inquiryInfo.answerDate = action.payload.answerDate;
        /**
         *  문의 답변 작성자
         */
        draft.csInquiryDetail.inquiryInfo.replyAuthor = action.payload.replyAuthor;
        /**
         *  답변 완료처리
         */
        draft.csInquiryDetail.inquiryInfo.isResponse = true;
      });
    },

    /**
     *  [1:1 문의 상세] 질문 내용 모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath([action.payload.name, 'isOpen'], action.payload.isOpen, draft);
        updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
      });
    },
  },
  initialState,
);
